import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import './index.css';
import './i18n';
import App from './App';
import { initializeRUM } from './utils/awsRum';
import logService from './utils/logService';

// AWS CloudWatch RUM の初期化
initializeRUM();

// アプリケーション初期化ログ
logService.logUserAction('app_started', {
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  timestamp: new Date().toISOString()
});

// React アプリケーションのマウント
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// Hot Module Replacement (開発環境用)
if (import.meta.hot) {
  import.meta.hot.accept();
}